export function getUtile ({ state, commit }, { search , page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pageutile', { params: { search, page } })
      .then((response) => {
        commit('setUtile', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getUtil ({ state, commit }, iId) {
  return new Promise((resolve, reject) => {
    if (iId) {
      axiosInstance.get('/v1/pageutile/' + iId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No item id'))
    }
  })
}

export function getCreateUtil ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/pageutile/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createUtil ({ state, commit }, newitem) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pageutile', newitem)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditUtil ({ state, commit }, iId) {
  return new Promise((resolve, reject) => {
    if (iId) {
      axiosInstance.get('/v1/pageutile/' + iId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No item id'))
    }
  })
}

export function editUtil ({ state, commit }, { id, item }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/pageutile/' + id, { ...item })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No item id'))
    }
  })
}

export function deleteUtil ({ state, commit }, iId) {
  return new Promise((resolve, reject) => {
    if (iId) {
      axiosInstance.delete('/v1/pageutile/' + iId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No item id'))
    }
  })
}

export function uploadFile ({ state, commit }, formData) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/pageutile/upload/1', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
